import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouse = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_264_3111)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M18.9627 0.427345C18.8635 0.183224 18.585 0.0649774 18.3409 0.166059L1.0369 7.22461C0.792779 7.32378 0.67644 7.60223 0.775614 7.84635C0.851902 8.03135 1.02927 8.14388 1.21808 8.14388C1.27721 8.14388 1.33824 8.13243 1.39736 8.10764L2.23462 7.76625V15.6888C2.23462 16.4993 2.89451 17.1592 3.70507 17.1592H16.0122C16.8228 17.1592 17.4827 16.4993 17.4827 15.6888V1.54496L18.7014 1.04719C18.9455 0.948011 19.0618 0.66956 18.9627 0.425438V0.427345ZM8.24039 16.2056V10.7319C8.24039 10.6538 8.30333 10.5927 8.37962 10.5927H11.5799C11.6581 10.5927 11.7191 10.6557 11.7191 10.7319V16.2056H8.23849H8.24039ZM16.5291 15.6888C16.5291 15.9748 16.2964 16.2056 16.0122 16.2056H12.6765V10.7319C12.6765 10.1293 12.1864 9.63912 11.5837 9.63912H8.38343C7.78076 9.63912 7.29061 10.1293 7.29061 10.7319V16.2056H3.70507C3.41899 16.2056 3.18822 15.9729 3.18822 15.6888V7.37718L16.5291 1.93403V15.6888Z",
				fill: "#141414"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_264_3111",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 18.2595,
				height: 17.0294,
				fill: "white",
				transform: "translate(0.740234 0.129883)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgHouse);
export { ForwardRef as ReactComponent };
